import Button from '@gaia/components/Button';
import theme from '@gaia/theme';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {Typography} from '@mui/material';

import illustration from './illustration.png';

export default function WelcomePage({setStepCount}: {setStepCount: SetState<number>}) {
    return (
        <div>
            <img
                style={{maxWidth: 250, textAlign: 'center'}}
                src={illustration}
                alt='Gaia GPS logo with different activities graphics.'
            />
            <Typography variant='body1' style={{marginBottom: theme.spacing(2)}}>
                Get set up with the maps you need.
            </Typography>
            <Button
                appearance='primary'
                fullWidth
                size='large'
                onClick={() => {
                    setStepCount((prevState: number) => prevState + 1);
                    ampli.startWebOnboarding();
                }}
            >
                Get Started
            </Button>
        </div>
    );
}
